// @flow
/**
 * Created by Mike Chung on 2/14/18.
 */
import type {ProfileLoadAction} from "../profileLoadAction";
import type {Profile} from "../../../components/profile/ProfilePage";

export function profileLoadAction(profile: ?Profile): ProfileLoadAction {
    return {
        type: "profile/LOAD_ACTION",
        profile: profile ? Object.assign(profile) : null
    }
}


// WEBPACK FOOTER //
// ./src/actions/profile/creators/profileLoadActionCreator.js